import { useGetAreasQuery } from 'api/AreasEndPoints';
import dayjs from 'dayjs';
import isNumber from 'lodash/isNumber';
import UserStatConfig from 'modules/Users/userStats/UserStatConfig';
import { CriteriaStat } from 'shared/model/statistic.model';
import { CriteriaContent } from 'shared/model/usageLog.model';
import { DATE_TIME_FORMAT, TIME_FORMAT } from 'utils/date-utils';

type Props = {
  stat: CriteriaStat;
  sameDay: boolean;
};

const UserStatCriteria = ({ stat, sameDay }: Props) => {
  const format = sameDay ? TIME_FORMAT : DATE_TIME_FORMAT;
  const criteriaDate = dayjs(stat.criteria.date);
  const dateStr = criteriaDate.format(format);
  const content = stat.criteria.content as CriteriaContent;

  const { data: areaData } = useGetAreasQuery({
    fields: ['id', 'name'],
  });

  const area = areaData?.find(a => a.id === content.areaId);

  let ratio = '';
  if (isNumber(content.ratio)) {
    ratio = content.ratio + '% Radar - ' + (100 - content.ratio) + '% Optical';
  }

  let revisitTime = '';
  if (isNumber(content.revisitTime)) {
    if (content.revisitTime === 0) {
      revisitTime = '0.5h';
    } else {
      revisitTime = content.revisitTime + 'h';
    }
  }

  return (
    <>
      <tr>
        <td className="text-right">{dateStr}</td>
        <td>Criteria</td>
        <td className="user-stat-content">
          <div>{area?.name}</div>
          <div>{ratio}</div>
          <div>Revist Time {revisitTime}</div>
        </td>
      </tr>
      {stat.configs.map(config => (
        <UserStatConfig
          key={config.id}
          stat={config}
          sameDay={criteriaDate.isSame(config.date, 'day')}
        />
      ))}
    </>
  );
};

export default UserStatCriteria;
